<template>
  <div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vx-card title="ORDER CREATE" >
          <template slot="actions">

            <vs-button icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to Orders
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="sample_list" :max-items="(meta.per_page) ? meta.per_page : 10" :data="services" @sort="handleSort"   :sst="true" stripe class="table-auto table-dark-inverted vs-con-loading__container">
              <template slot="header">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                          v-model="filters['search']"
                          class="w-full px-3 pb-5 rounded-full is-label-placeholder md:w-1/3 xl:w-1/7" />
                <vs-button id="place_order" :disabled="cartItems.length === 0"  icon-pack="feather" icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  Place order ({{cartItems.length}} Items)
                </vs-button>
              </template>

              <template slot="thead">
                <vs-th width="20%" sort-key="created_at">NAME</vs-th>
                <vs-th width="30%">DESCRIPTION</vs-th>
                <vs-th width="15%">QUANTITY</vs-th>
                <vs-th width="15%">UNIT PRICE (GBP)</vs-th>
                <vs-th width="10%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description}}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" rules="" v-slot="{ errors }">
                      <vs-input  type="text" v-model="data[indextr].quantity" class="w-full" :ref="indextr+'quantity'" placeholder="Enter Quantity"
                                  :name="indextr+'quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </vs-td>

                  <vs-td :data="data[indextr].unit_price">
                    <ValidationProvider :vid="indextr + 'unit_price' " :name="indextr + 'unit_price'" rules="{required: false, regex: /^\d*\.?\d*$/}"  v-slot="{ errors }">
                      <vs-input  type="text" v-model="data[indextr].unit_price" class="w-full" placeholder="Enter Price"
                          :name="indextr+'unit_price'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="" text="Add to cart" position="left">
                        <vs-button :id="'add_button'+''+ indextr" v-if="!checkSampleInCart(data[indextr])" v-bind:disabled="!data[indextr].quantity || !data[indextr].unit_price"
                                   @click.native="onClickAddToCart(data[indextr].id, data[indextr], indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>
                      </vx-tooltip>
                      <!-- <vx-tooltip class="" text="Remove from cart" position="left">
                        <vs-button :id="'remove_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])" @click.native="onClickRemoveFromCart(data[indextr].id, indextr)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                      </vx-tooltip> -->

                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-other-supplier-order-pop-up ref="CreateOtherSupplierOrderPopUp"  v-bind:cartItems="cartItems"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import CreateOtherSupplierOrderPopUp from '@/components/popups/other-suppliers/orders/CreateOtherSupplierOrderPopUp'
  import { defaultPagination, perPageList } from '@/constants/config';

  const OtherSupplierRepository = RepositoryFactory.get('other_supplier')

  export default {
    name: 'AllServiceList',
    data () {
      return {
        supplier_id: '',
        services: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        cartItems: [],
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateOtherSupplierOrderPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.supplier_id = this.$route.params.id ? this.$route.params.id : null
    },
    methods: {
      async refreshData () {
        await this.loadService()
        this.$emit('back')
      },
      async onlyRefreshData() {
        await this.loadService()
      },
      async loadService() {
        try {
          await this.$vs.loading()
          let data = {}
          if(!!this.supplier_id) {
            data = (await OtherSupplierRepository.getListOfServices(this.supplier_id, this.page, this.filterQuery, this.perPage, this.sort)).data
          } else {
            data = (await OtherSupplierRepository.getListOfServices(null, this.page, this.filterQuery, this.perPage, this.sort)).data
          }
          this.services =  data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async onClickAddToCart(id, data, indextr) {
        await this.$vs.loading({
          container: `#add_button${indextr}`,
          scale: 0.45
        })
        try {
          this.cartItems.push({
            quantity: data.quantity,
            other_supplier_service_id: id,
            unit_price: parseFloat(data.unit_price).toFixed(2),
            name: data.name,
            category: data.category.name,
            description: data.description
          });
          this.showSuccessMessage('Added to the Cart')
          this.services[indextr].quantity = null
          this.services[indextr].unit_price = null
          // await this.loadService()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#add_button${indextr} > .con-vs-loading`)
      },
      async onClickRemoveFromCart(id, indextr) {
        await this.$vs.loading({
          container: `#remove_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.other_supplier_service_id === id )
          this.cartItems = this.cartItems.filter(element => element !== search);
          this.showSuccessMessage('Removed from cart')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
      },

      async getItemsInItemsCart() {
        await this.$vs.loading({
          container: '#place_order',
          scale: 0.45
        })
        try {
          const {data} = (await OtherSupplierRepository.getItemsInItemsCart(this.supplier_id)).data
          this.cartItems = data
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#place_order > .con-vs-loading')
      },
      async onClickPlaceOrder() {
        await this.$refs.CreateOtherSupplierOrderPopUp.openPopup(this.supplier_id)
      },

      filterQueryUpdate (){
        this.loadService()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadService()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadService()
        }
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return '#f05945';
          case 4:
            return '#f58634';
          case 5:
            return '#206a5d';
        }
      },
      checkSampleInCart: function (object) {
        return false
        const arr = this.cartItems.filter((n) => n.other_supplier_service_id === object.id)
        return arr.length > 0
      }

    },
    watch : {
      page(){
        this.loadService()
      }
    },
    computed: {

    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
